
export default function (value, len = 80) {
    if ( !value ) return value;

    if ( value.length > ( len -3) ) {
        return `${value.substr(0, len)}...`;
    }

    return value;

}
